import { Box, Typography } from "@mui/material";
import {
  Logo,
  Point1,
  Point2,
  Point3,
  Root,
  Text,
} from "./Authentication.styles";

const AuthenticationRedirecting: React.FC = () => {
  return (
    <Root>
      <Text variant="h5">
        <img
          src="/assets/images/savio-filoblu-small.gif"
          alt="savio-filoblu-small.gif"
        ></img>
        <Box>
          Loading<Point1>.</Point1>
          <Point2>.</Point2>
          <Point3>.</Point3>
        </Box>
      </Text>
      <Logo />
    </Root>
  );
};

export default AuthenticationRedirecting;
